




import Vue from 'vue'

export default Vue.extend({
  name: 'IconLink',
  methods: {
    click () {
      this.$emit('onClick')
    }
  }
})
